<template>
    <div>Componente de Defensa del consumidor</div>
</template>

<script></script>